import styled from 'styled-components';

import { MpText } from 'shared/ui/MpText';

export const PaymentDateContainerStyled = styled.div`
	gap: 4px;
	display: flex;
	flex-direction: column;
`;

export const PopoverTextStyled = styled(MpText)`
	gap: 4px;
	display: flex;
	align-items: center;
`;
